export const PasswordPolicyQuery = `{
    allPasswordPolicy {
        id
        companyId
        policyName
        isActive
        minLength
        requireLowercase
        requireUppercase
        requireDigit
        requireSpecialChar
        allowedSpecialChars
        maxPasswordAgeDays
        minPasswordAgeDays
        passwordHistoryCount
        maxConsecutiveRepeats
        maxFailedAttempts
        lockoutDurationMinutes
        failedAttemptWindowMins
        prohibitUsername
        prohibitFirstName
        prohibitLastName
        prohibitDictionaryWords
        minSubstringLength
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}`;
